/*
 * Copyright (C) 2013-2018 MNEMOTIX <http://www.mnemotix.com/> and/or its affiliates
 * and other contributors as indicated by the @author tags.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export {mockObject} from "./utilities/apollo/mutation/generateUpdateCallback";

export {
  UserAuthenticationService,
  gqlMeQuery, 
  gqlRegisterUserAccountMutation, 
  gqlLoginMutation, 
  gqlLogoutMutation,
  gqlResetUserAccountPasswordMutation,
  gqlResetUserAccountPasswordByMailMutation,
  gqlUnregisterUserAccountMutation
} from './services/UserAuthenticationService';
export {NotificationService} from './services/NotificationService';
export {usePaginatedQuery} from './utilities/apollo/query/usePaginatedQuery';
export {apolloErrorHandler} from './utilities/apollo/apolloErrorHandler';
export {ParseNewlines} from './utilities/react/ParseNewlines';
export {SanitizedHtml} from './utilities/react/SanitizedHtml';
export {fr as frLocale} from './locales/fr';
export {GeolocService} from "./services/GeolocService";
export {GenericFuzzySearcher} from "./utilities/GenericFuzzySearcher";
export {useGeolocService} from "./utilities/react/hooks/useGeolocService";
export {handleGraphQLError} from "./utilities/handleGraphQLError";

export {
  prepareMutation,
  generateRemoveCallback,
  generateUpdateCallback,
  normalizeMutationInput,
  MutationConfig
} from "./utilities/apollo/mutation";

export {
  normalizeObjectIntoFormInitialValues,
  DynamicFormDefinition,
  MixedLinkInputDefinition,
  LinkInputDefinition
} from "./utilities/form";

// Retro Compat
export {generateRemoveCallback as apolloRemoveNodeCacheUpdate} from './utilities/apollo/mutation/generateRemoveCallback';